export const communitiesForSelect = state => {
  if (state.selectFilterText !== '') {
    return state.communityList.filter(community => {
      return community.name.toLowerCase().indexOf(state.selectFilterText) >= 0
    })
  } else {
    return state.communityList
  }
}

export const selectedCommunities = state => {
  return state.communityList.filter(community => {
    return community.selected
  })
}

export const selectedCommunitiesCount = state => {
  let communities = state.communityList.filter(community => {
    return community.selected
  })
  return communities.length
}

export const currentMetricLabels = state => {
  if (state.selectedMetricCategory === null) {
    return []
  } else {
    return state.metrics[state.selectedMetricCategory.name]
  }
}

export const metricsForCommunoty = (state, community) => {
  return state.communityMetrics[community.name][state.selectedMetricCategory.name]
}

export const pendingCommunities = state => {
  return state.pendingCommunities.length > 0
}

// This should really be calculated in the original data download.
// If I do it in the original data download then I need to aggregate each region by the three categories.
export const AEAEnergyRegionsWithScore = (state) => {
  let currentMetricCategory = state.selectedMetricCategory
  let regions = state.AEAEnergyRegions
  for (let i = 0; i < regions.length; i++) {
    let communities = state.communityList.filter(community => {
      return community.aea_energy_region === regions[i].id
    })
    let count = communities.length
    let total = communities.reduce(function (prev, next) {
      return prev + parseInt(next[currentMetricCategory.name])
    }, 0)
    regions[i].score = Math.round(total / (count + 0.0))
  }
  return regions
}

export const AEAEnergyRegionsForSelect = state => {
  let regions = AEAEnergyRegionsWithScore(state)
  if (state.selectFilterText !== '') {
    return regions.filter(region => {
      return region.name.toLowerCase().indexOf(state.selectFilterText) >= 0
    })
  } else {
    return regions
  }
}

export const AEAEnergyRegionChecked = (state) => (regionID) => {
  return state.communityList.filter(community => {
    return community.aea_energy_region === regionID
  }).reduce(function (prev, next) {
    return prev && (next.selected)
  }, true)
}

export const CensusAreasWithScore = (state) => {
  let currentMetricCategory = state.selectedMetricCategory
  let CensusAreas = state.CensusAreas
  for (let i = 0; i < CensusAreas.length; i++) {
    let communities = state.communityList.filter(community => {
      return community.census_area === CensusAreas[i].id
    })
    let count = communities.length
    let total = communities.reduce(function (prev, next) {
      return prev + parseInt(next[currentMetricCategory.name])
    }, 0)
    CensusAreas[i].score = Math.round(total / (count + 0.0))
  }
  return CensusAreas
}

export const CensusAreasForSelect = state => {
  let areas = CensusAreasWithScore(state)
  if (state.selectFilterText !== '') {
    return areas.filter(area => {
      return area.name.toLowerCase().indexOf(state.selectFilterText) >= 0
    })
  } else {
    return areas
  }
}

export const CensusAreaChecked = (state) => (censusAreasID) => {
  return state.communityList.filter(community => {
    return community.census_area === censusAreasID
  }).reduce(function (prev, next) {
    return prev && (next.selected)
  }, true)
}

export const CensusAreaCommunities = (state) => (censusAreaID) => {
  return state.communityList.filter(community => {
    return community.census_area === censusAreaID
  })
}



// WEBPACK FOOTER //
// ./src/store/getters.js